import { isRequired, isValidEmail, isValidPhone, validateName,isValidPassword } from '../../utils/Validate';
import { ValidateMessages } from '../../constants/ValidateConstants';

export default function Validation(values) {
  let errors = {};

  if (!isRequired(values.firstName)) {
    errors.firstName = ValidateMessages?.REQUIRED("First name");
  } else if (values.firstName.trim() === '') {
    errors.firstName = ValidateMessages?.BLANK_SPACE("First name");
  } else {
    const nameError = validateName(values.firstName);
    if (nameError) {
      errors.firstName = nameError;
    }
  }
  if (!isRequired(values.lastName)) {
    errors.lastName = ValidateMessages?.REQUIRED("Last name");
  } else if (values.lastName.trim() === '') {
    errors.lastName = ValidateMessages?.BLANK_SPACE("Last name");
  } else {
    const nameError = validateName(values.lastName);
    if (nameError) {
      errors.lastName = nameError;
    }
  }
  if (!isRequired(values.phone)) {
    errors.phone = ValidateMessages?.REQUIRED("Phone");
  } else if (!isValidPhone(values.phone)) {
    errors.phone = ValidateMessages?.NOT_VALID("Phone number");
  }
  if (!isRequired(values.userName) && !values?.id && values?.userName !== "undefined") {
    errors.userName = ValidateMessages?.REQUIRED("Email");
  } else if (!isValidEmail(values.userName) && !values?.id && values?.userName !== "undefined") {
    errors.userName = ValidateMessages?.NOT_VALID("Email");
  }
  if (!values.password && !values?.id) {
    errors.password = ValidateMessages?.REQUIRED("Password");
  } else if (isRequired(values.password) && !values?.id && !isValidPassword(values.password)) {
    errors.password = ValidateMessages?.PASSWORD_RESTRICTION;
  }
  if (!values.userType) {
    errors.userType = ValidateMessages?.REQUIRED("User type");
  }
  if (!values.userCompanyId) {
    errors.userCompanyId = (values.userType === "2")
      ? ValidateMessages?.REQUIRED("Distributor name")
      : ValidateMessages?.REQUIRED("Company name");
  }
  if (!values.departmentId) {
    errors.department = ValidateMessages?.REQUIRED("Department");
  }
  if (!values.designationId) {
    errors.designation = ValidateMessages?.REQUIRED("Designation");
  }
  if (!values.roleId) {
    errors.roleId = ValidateMessages?.REQUIRED("Role");
  }
  if (!values.reportingTo) {
    errors.reportingTo = ValidateMessages?.REQUIRED("Reporting to");
  }
  
  let error = {}
  Object.keys(errors).map((key, index) => {
    if (errors[key] !== undefined)
      error[key] = errors[key]
  })
  return error;
}

